import * as AWSCognito from 'amazon-cognito-identity-js';
import userPool from '../services/AWSCognito';
import commonStore from './commonStore';
import { observable, action, computed } from 'mobx';
import 'promise.prototype.finally';

const jwtDecode = require('jwt-decode');

let cognitoUser: any = null;

interface NewRequiredPassword {
  newPasswordRequired?: (
    callbacks: {
      callback: (newPassword: string, requiredAttribs: { [key: string]: any}) => any,
      error: (err: any) => any,
    },
    userAttributes: any,
    requiredAttributes: any
  ) => any;
  onSuccess?: (result: any) => void;
  onFailure?: (err: any) => void;
}

export class AuthStore {
  @observable inProgress = false;
  @observable inNewPassProgress = false;
  @observable errors: any = undefined;
  @observable isFirst = true;
  @observable
  values = {
    userName: '',
    email: '',
    name: '',
    phone_number: '',
    password: '',
    code: ''
  };
  @observable message: string|null = null;
  @observable currentUser: any = undefined;
  @observable oldPassword = '';
  @observable newPassword = '';
  @observable deleteButton = false;
  @observable jwtToken = '';
  @observable groups = [];
  @observable clientId = '';
  @observable isSuperUser = false;
  @observable isAdministrator = false;
  @computed get isGuest() {
    return !this.isSuperUser && this.clientId === 'global';
  }

  @action
  setCurrentUser(_currentUser: any) {
    let currentUser = this.currentUser || {};
    for (let key in _currentUser) {
      if (key !== 'prototype') {
        currentUser[key] = _currentUser[key];
      }
    }
    this.currentUser = currentUser;
  }

  @action
  resetCurrentUser() {
    this.currentUser = undefined;
  }

  setName(name: any) {
    this.values.name = name;
  }

  @action
  setCode(code: any) {
    this.values.code = code;
  }

  @action
  setEmail(email: any) {
    this.values.email = email;
  }

  @action
  setPhoneNumber(phoneNumber: any) {
    this.values.phone_number = phoneNumber;
  }

  @action
  setUserName(userName: any) {
    this.values.userName = userName;
  }

  @action
  setPassword(password: any) {
    this.values.password = password;
  }

  @action
  setOldPassword(password: any) {
    this.oldPassword = password;
  }

  @action
  setNewPassword(password: any) {
    this.newPassword = password;
  }

  @action
  setDeleteButton(press: any) {
    this.deleteButton = press;
  }

  @action
  setMessage(message: any) {
    this.message = message;
  }

  @action
  reset() {
    this.errors = '';
    this.message = '';
    this.values = {
      email: '',
      password: '',
      code: '',
      userName: '',
      name: '',
      phone_number: ''
    };
    this.deleteButton = false;
  }

  @action
  setClient(value: string) {
    this.clientId = value;
    window.localStorage.setItem('currentClient', value);
  }

  @action setJWTToken(token: any) {
    this.jwtToken = token;
  }

  @action
  verifySession() {
    let hasSession = Object.keys(localStorage).some((key) => {
      return typeof key.match('CognitoIdentityServiceProvider') !== 'undefined';
    });

    if (hasSession) {
      this.setCognito();
    } else {
      this.loginGuest();
      commonStore.setAppLoaded();
    }
  }

  @action
  setSuperUser(val: boolean) {
    this.isSuperUser = val || true;
  }

  @action
  setClientId(currentClient: string) {
    this.clientId = currentClient;
  }

  @action
  setCognito() {
    let me = this;
    return new Promise((res, rej) => {
      cognitoUser = userPool.getCurrentUser();
      return cognitoUser !== null ? res() : rej();
    
    })
    .then(() => {
      return new Promise((res, rej) => {
        cognitoUser.getSession(function(err: any, session: any) {
          if (err) {
            return rej(err);
          }
          let sessionIdToken = session.getIdToken();
          if (me.isFirst)  {
            me.isFirst = false;
            if (session) {
              let refreshToken = session.getRefreshToken();
               
              if (refreshToken) {
                cognitoUser.refreshSession(
                  refreshToken, 
                  ( ) => me.verifySession()
                );
              }
            }
            
          }
          let jwtToken = sessionIdToken.jwtToken;
          me.setJWTToken(jwtToken);
          let sessionIdInfo = jwtDecode(me.jwtToken);
          let groupId = 'guest';
          let sessionGroups = sessionIdInfo['cognito:groups'];
          let group = 'global';
          if ( 
            Array.isArray(sessionGroups)
            && sessionGroups.length > 0
          ) {
            for (let c = 0; c < sessionGroups.length; c++) {
              group = sessionGroups[c];
              switch (group) {
                case 'SuperUser':
                  me.setSuperUser(true);
                  let currentClient = window.localStorage.getItem('currentClient');
                  
                  if (!currentClient ) {
                    currentClient = 'global';
                  }
                  me.setClientId(currentClient);
                  break;
                case 'Administrator':
                  me.isAdministrator = true;
                  break;
                case 'DataHandler':
                  break;
                default :
                  window.localStorage.setItem('currentClient', group);
                  me.setClientId(group);
                  groupId = group;
                  break;
              }
            }
          } else {
            me.setClientId(group);
          }

          me.setCurrentUser({ groupId });
          
          return res();
        });
      });
    })
    .then(() => {
      return new Promise((res, rej) => {
        cognitoUser.getUserAttributes((err: any, attributes: any) => {
          if (err) {
            return rej(err);
          }
          res(attributes);
        });
      });
    })
    .then(attributes => {
      return new Promise((res, rej) => {
        (attributes as any[]).map((key: any) => {
          this.setCurrentUser({[key.Name]: key.Value});
        });
        res();
      });
    })
    // Empty method needed to avoid warning.
    // tslint:disable-next-line:no-empty
    .catch((err: any) => {})
    .finally(() => {
      if (
        typeof me.clientId !== 'string' ||
        me.clientId.length === 0
      ) {
        me.loginGuest();
      }
      
      commonStore.setAppLoaded();
    });
  }

  @action
  loginGuest() {
    this.inProgress = true;
    this.errors = undefined;
    const Username = 'guest';
    const Password = 'Hustl3it$';

    let authenticationDetails = new AWSCognito.AuthenticationDetails({
      Username,
      Password
    });

    cognitoUser = new AWSCognito.CognitoUser({
      Username,
      Pool: userPool
    });

    return this._login(authenticationDetails, {
      onSuccess: () => 0, 
      onFailure: () => 0
    });
  }

  @action
  login(newRequiredPassword: NewRequiredPassword) {
    this.inProgress = true;
    this.errors = undefined;
    const { userName } = this.values;
    let authenticationDetails = new AWSCognito.AuthenticationDetails({
      Username: userName,
      Password: this.values.password
    });

    cognitoUser = new AWSCognito.CognitoUser({
      Username: userName,
      Pool: userPool
    });
    return this._login(authenticationDetails, newRequiredPassword);
  }

  @action
  _login(
    authenticationDetails: AWSCognito.AuthenticationDetails, 
    { newPasswordRequired, onSuccess, onFailure}: NewRequiredPassword
  ) {
    
    return new Promise((res, rej) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result: any) => {
          // tslint:disable-next-line:no-unused-expression
          onSuccess && onSuccess.apply && onSuccess.apply(this, result);
          return res();
        },
        onFailure: (err: any) => {
          // tslint:disable-next-line:no-unused-expression
          onFailure && onFailure.apply && onFailure.apply(this, err);
          return rej(err);
        },
        newPasswordRequired: ( userAttributes: any, requiredAttributes: any) => {
          if (typeof newPasswordRequired === 'undefined') {
            return res();
          } else {
            return newPasswordRequired(
              {
                callback: (newPassword, attributes) => {
                  this.inNewPassProgress = true;
                  return new Promise((resPass, rejPass) => {
                    return cognitoUser.completeNewPasswordChallenge( newPassword, attributes, {
                      onSuccess: (result: any) => {
                        // tslint:disable-next-line:no-unused-expression
                        onSuccess && onSuccess.apply && onSuccess.apply(this, result);
                        return resPass();

                      },
                      onFailure: (err: any) => {
                        // tslint:disable-next-line:no-unused-expression
                        onFailure && onFailure.apply && onFailure.apply(this, err);
                        return rejPass(err);
                      }
                    });
                  })
                  .then(() => {
                    res();
                  })
                  .catch(
                    action(err => {
                      this.errors = this.simpleErr(err);
                      throw err;
                    })
                  )
                  .finally(
                    action(() => {
                      this.inNewPassProgress = false;
                    })
                  );
                },
                error: (err: any) => {
                  // tslint:disable-next-line:no-unused-expression
                  onFailure && onFailure.apply && onFailure.apply(this, err);
                  this.simpleErr(err);
                  throw err;
                }
              },
              userAttributes,
              requiredAttributes
            );
          }
        }
      });
    })
    .then(() => {
      this.verifySession();
    })
    .catch(
      action(err => {
        this.errors = this.simpleErr(err);
        throw err;
      })
    )
    .finally(
      action(() => {
        this.inProgress = false;
      })
    );
  }

  @action
  register() {
    this.inProgress = true;
    this.errors = undefined;
    return new Promise((res, rej) => {
      userPool.signUp(
        this.values.userName,
        this.values.password,
        [
          new AWSCognito.CognitoUserAttribute({ Name: 'name', Value: this.values.name}),
          new AWSCognito.CognitoUserAttribute({ Name: 'email', Value: this.values.email}),
          new AWSCognito.CognitoUserAttribute({ Name: 'phone_number', Value: this.values.phone_number})
        ],
        [],
        (err, result) => {
          if (err) {
            return rej(err);
          }
          cognitoUser = result;
          res();
        }
      );
    })
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }

  @action
  confirmCode() {
    this.inProgress = true;
    this.errors = undefined;

    cognitoUser = new AWSCognito.CognitoUser({
      Username: this.values.email,
      Pool: userPool
    });

    return new Promise((res, rej) => {
      cognitoUser.confirmRegistration(this.values.code, true, (err: any) => {
        return err ? rej(err) : res();
      });
    })
      .then(
        action(() => {
          this.setMessage('You\'re confirmed! Please login...');
        })
      )
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }

  @action
  logout() {
    return new Promise(res => {
      if (cognitoUser !== null) {
        cognitoUser.signOut();
        cognitoUser = null;
      }
      this.resetCurrentUser();
      res();
    });
  }

  @action
  changePassword() {
    this.inProgress = true;
    this.errors = undefined;

    return new Promise((res, rej) => {
      cognitoUser.changePassword(
        this.oldPassword,
        this.newPassword,
        (err: any, result: any) => {
          if (err) {
            return rej(err);
          }
          return res();
        }
      );
    })
      .then(
        action(() => {
          this.setMessage('Changes saved.');
        })
      )
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }

  @action
  deleteAccount() {
    this.inProgress = true;
    this.errors = undefined;

    return new Promise((res, rej) => {
      if (!this.deleteButton) {
        return rej({
          message: 'To delete your account please click the checkbox.'
        });
      }
      cognitoUser.deleteUser((err: any, result: any) => {
        if (err) {
          return rej(err);
        }
        window.localStorage.clear();
        this.resetCurrentUser();
        return res();
      });
    })
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }

  simpleErr(err: any) {
    switch (err.code) {
      case 'UserNotConfirmedException':
        return {
          statusCode: 0,
          code: 'Unverified Account: please verify your email address.',
          message: 'Check your inbox for the verification link.'
        };
      default:
        return {
          statusCode: err.statusCode,
          code: err.code,
          message: err.message
        };
    }
  }
}

export default new AuthStore();


// WEBPACK FOOTER //
// ./src/stores/authStore.ts